import React from 'react';
import { Flame } from 'lucide-react';
import { motion } from 'framer-motion';
interface ConsistencyStreakProps {
  days: number;
  isActive: boolean;
}
export function ConsistencyStreak({
  days,
  isActive
}: ConsistencyStreakProps) {
  return <div className="flex flex-col items-center justify-center p-4 bg-orange-50 rounded-2xl border border-orange-100" data-id="element-146">
      <div className="relative mb-2" data-id="element-147">
        <motion.div animate={isActive ? {
        scale: [1, 1.1, 1],
        filter: ['brightness(1)', 'brightness(1.2)', 'brightness(1)']
      } : {}} transition={{
        duration: 2,
        repeat: Infinity
      }} className={`p-3 rounded-full ${isActive ? 'bg-[var(--primary)] text-white shadow-lg shadow-orange-200' : 'bg-gray-200 text-gray-400'}`} data-id="element-148">
          <Flame size={24} fill={isActive ? 'currentColor' : 'none'} data-id="element-149" />
        </motion.div>
        {isActive && <motion.div className="absolute -top-1 -right-1 bg-yellow-400 text-[10px] font-bold px-1.5 py-0.5 rounded-full text-yellow-900 border border-white" initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} transition={{
        delay: 0.5
      }} data-id="element-150">
            ON FIRE
          </motion.div>}
      </div>
      <div className="text-center" data-id="element-151">
        <span className="block text-2xl font-bold text-[var(--secondary)]" data-id="element-152">
          {days}
        </span>
        <span className="text-xs text-gray-500 font-medium uppercase tracking-wide" data-id="element-153">
          Dias Seguidos
        </span>
      </div>
    </div>;
}